import axios from "axios";
import store from "../redux/store";
import { logout } from "../redux/actions/userActions";

import { API_PROXY } from "../сonstants/apiConstants";

const api = axios.create({
  baseURL: `${API_PROXY}`,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response.status === 401) {
      store.dispatch(logout());
    }
    if (err.response.status === 404) {
      window.location = "/errors/404";
    }
    // if (err.response.status === 500) {
    //   window.location = "/errors/500";
    // }
    return Promise.reject(err);
  }
);

export default api;
